export const SHOW_CONTEXT_MENU = "SHOW_CONTEXT_MENU";
export const HIDE_CONTEXT_MENU = "HIDE_CONTEXT_MENU";
export const FETCH_CONTEXT_MENU_SUCCESS = "FETCH_CONTEXT_MENU_SUCCESS";
export const SHOW_CONTEXT_INFO = "SHOW_CONTEXT_INFO";
export const LAUNCH_PROCESS_FROM_RIGHT_CLICK = "LAUNCH_PROCESS_FROM_RIGHT_CLICK";
